import React, { ReactNode, createContext, useContext, useEffect } from 'react';

type BrandLanguage = {
  brandName: string;
  brandSite: string;
  brandContact: string;
};

// Static brand language - JotPsych only
const brandLanguage: BrandLanguage = {
  brandName: 'JotPsych',
  brandSite: 'jotpsych.com',
  brandContact: 'contact@jotpsych.com',
};

type BrandLanguageContextType = {
  brandLanguage: BrandLanguage;
};

const BrandLanguageContext = createContext<BrandLanguageContextType>({
  brandLanguage,
});

export const useBrandLanguage = () => useContext(BrandLanguageContext);

export const BrandLanguageProvider = ({ children }: { children: ReactNode }) => {
  useEffect(() => {
    document.title = `${brandLanguage.brandName} — AI-Powered Medical Charting`;
  }, []);

  return (
    <BrandLanguageContext.Provider value={{ brandLanguage }}>
      {children}
    </BrandLanguageContext.Provider>
  );
};
